import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {useEffect, useState} from 'react';
import { cgcUploadTypes  } from '../../../helper/namespace';
import DocModal from './DocModal';



export default function TabTable2({uploads}) {
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [photoUploads, setPhotoUploads] = useState([])
  const [nicUploads, setNicUploads] = useState([])
  const [signatureUploads, setSignatureUploads] = useState([])
  const [alUploads, setAlUploads] = useState([])
  const [olUploads, setOlUploads] = useState([])
  const [workUploads, setWorkUploads] = useState([])
  const [otherUploads, setOtherUploads] = useState([])
  const [docModal, setDocModal] = useState(false)
  const [uploadType, setUploadType] = useState(null)

  const handleSeperationUploadTypes = (uploads_=[]) => {
    const photos = []
    const nics = []
    const signatures = []
    const als = []
    const ols = []
    const works = []
    const others = []
    uploads_.forEach(doc => {
      switch(doc.upload_type_id){
        case cgcUploadTypes.CGC_PHOTO_UPLOADS.id:
          photos.push(doc)
          break
        case cgcUploadTypes.CGC_NIC_UPLOADS.id:
          nics.push(doc)
          break
        case cgcUploadTypes.CGC_SIGNATURE_UPLOADS.id:
          signatures.push(doc)
          break
        case cgcUploadTypes.CGC_AL_UPLOADS.id:
          als.push(doc)
          break
        case cgcUploadTypes.CGC_OL_UPLOADS.id:
          ols.push(doc)
          break
        case cgcUploadTypes.CGC_WORK_UPLOADS.id:
          works.push(doc)
          break
        case cgcUploadTypes.CGC_OTHER_UPLOADS.id:
          others.push(doc)
          break
      }
    })
    const modifiedData = []
    Object.entries(cgcUploadTypes).map(([key,value]) => {
      switch(value.id){
        case cgcUploadTypes.CGC_PHOTO_UPLOADS.id:
          modifiedData.push({...value, uploads:photos})
          break
        case cgcUploadTypes.CGC_NIC_UPLOADS.id:
          modifiedData.push({...value, uploads:nics})
          break
        case cgcUploadTypes.CGC_SIGNATURE_UPLOADS.id:
          modifiedData.push({...value, uploads:signatures})
          break
        case cgcUploadTypes.CGC_AL_UPLOADS.id:
          modifiedData.push({...value, uploads:als})
          break
        case cgcUploadTypes.CGC_OL_UPLOADS.id:
          modifiedData.push({...value, uploads:ols})
          break
        case cgcUploadTypes.CGC_WORK_UPLOADS.id:
          modifiedData.push({...value, uploads:works})
          break
        case cgcUploadTypes.CGC_OTHER_UPLOADS.id:
          modifiedData.push({...value, uploads:others})
          break
      }
    })
    setUploadedFiles(modifiedData)
  }
  useEffect(() => {
    handleSeperationUploadTypes(uploads)
  },[uploads])
  
  useEffect(() => {
    if(!docModal){
      setUploadType(null)
    }
  },[docModal])

  const toggleDocModal = () => {
    setDocModal(!docModal)
  }


  return (
    <div>
      <DocModal toggleDocModal={toggleDocModal} docModal={docModal} uploadType={uploadType}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableBody>
            {Object.entries(uploadedFiles).map(([key,value]) => {
              return (
                <TableRow
                  key={key}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {value.name}
                  </TableCell>
                  <TableCell align="right">
                    <button className="tblCell stdcourses" onClick={()=>{
                      setUploadType(value)
                      toggleDocModal()
                    }}>
                      <VisibilityIcon />
                    </button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
